import { DeepMap, FieldError } from 'react-hook-form';

export const getErrorMessageForm = ({
    name,
    errors,
    touched,
    isSubmitted,
    externalErrorMessage
}: {
    name: string;
    errors: DeepMap<Record<string, any>, FieldError>;
    touched: DeepMap<Record<string, any>, true>;
    isSubmitted: boolean;
    externalErrorMessage?: string;
}) => {
    if (externalErrorMessage) {
        return externalErrorMessage;
    }
    if (!isSubmitted && !touched[name]) {
        return null;
    }
    const fieldErrors = errors[name] || null;
    return fieldErrors?.[0]?.message || fieldErrors?.message || fieldErrors || null;
};
